import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import buttonStyles from '../ui/Button/Button.scss';
import {LinkButton} from '../ui/LinkButton/LinkButton';
import styles from './DownloadLinks.scss';

export function DownloadLinks(props) {
  const {downloadLinks, onDownloadClick} = props;
  const {t} = useTranslation();
  const handleClick = (format) => () => onDownloadClick(format);
  const linkButtonClassName = classNames(styles.downloadLink, buttonStyles.big);
  return (
    <div data-hook="downloadLinks">
      {downloadLinks.mp3 ? (
        <LinkButton
          className={linkButtonClassName}
          href={downloadLinks.mp3}
          onClick={handleClick('mp3')}
          dataHook="mp3Link"
        >
          {t('mgw.downloadMP3')}
        </LinkButton>
      ) : null}
      {downloadLinks.flac ? (
        <LinkButton
          className={linkButtonClassName}
          href={downloadLinks.flac}
          onClick={handleClick('flac')}
          dataHook="flacLink"
        >
          {t('mgw.downloadFlac')}
        </LinkButton>
      ) : null}
    </div>
  );
}

DownloadLinks.propTypes = {
  t: PropTypes.func,
  downloadLinks: PropTypes.object.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
};
